module.exports = __webpack_public_path__ + "media/src/images/header/menu-7e41bef823a1a5b77107e770299b3f8e.svg";